module.exports = __webpack_public_path__ + "static/mobilitaet-7fa30b9a0b6f9439e181d34da45c2b7a.png";